import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createBlock(_component_ButtonComponent, {
    class: "download-button",
    buttonType: "button",
    mod: _ctx.mod,
    disabled: _ctx.disabled || _ctx.loading,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, {
    default: _withCtx(() => [
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_IconComponent, {
            key: 0,
            name: _ctx.iconName
          }, null, 8, ["name"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(_ctx.loading ? 'Загрузка...' : _ctx.text), 1)
    ]),
    _: 1
  }, 8, ["mod", "disabled"]))
}